import { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SiteProvider } from "./context/SiteContext";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Timeline from "./components/Timeline";
import Origins from "./components/Origins";
import TheName from "./components/TheName";
import Lineage from "./components/Lineage";
import FamilyTree from "./components/FamilyTree";
import Kin from "./components/Kin";
import Legacy from "./components/Legacy";
import ClanMap from "./components/ClanMap";
import Roots from "./components/Roots";
import ForsteVillage from "./components/ForsteVillage";
import Distribution from "./components/Distribution";
import Marquee from "./components/Marquee";
import Bloodline from "./components/Bloodline";
import Gathering from "./components/Gathering";
import Kindred from "./components/Kindred";
import Footer from "./components/Footer";
import PressPage from "./components/PressPage";
import RecipesPage from "./components/RecipesPage";
import GuestbookPage from "./components/GuestbookPage";
import ContactPage from "./components/ContactPage";
import AdminPage from "./components/AdminPage";
import CavePage from "./components/CavePage";
import NotablePage from "./components/NotablePage";
import HezPage from "./components/HezPage";
import BronzeAgeWorld from "./components/BronzeAgeWorld";
import { Toaster } from "./components/ui/toaster";

const STORAGE_KEY = "huchthausen_pledges";

function Home() {
  const [pledges, setPledges] = useState([]);

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (Array.isArray(saved)) setPledges(saved);
    } catch (e) {
      /* ignore */
    }
  }, []);

  const addPledge = (p) => {
    setPledges((prev) => {
      const next = [...prev, p];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  return (
    <div className="App bg-ink">
      <Nav />
      <Hero />
      <Timeline />
      <Origins />
      <TheName />
      <Lineage />
      <FamilyTree />
      <Kin />
      <Legacy />
      <ClanMap />
      <Roots />
      <ForsteVillage />
      <Distribution />
      <BronzeAgeWorld />
      <Marquee />
      <Bloodline />
      <Gathering onPledge={addPledge} />
      <Kindred pledges={pledges} />
      <Footer />
      <Toaster />
    </div>
  );
}

function Press() {
  return (
    <div className="App bg-ink">
      <Nav />
      <PressPage />
      <Footer />
    </div>
  );
}

function RecipesRoute() {
  return (
    <div className="App bg-ink">
      <Nav />
      <RecipesPage />
      <Footer />
    </div>
  );
}

function GuestbookRoute() {
  return (
    <div className="App bg-ink">
      <Nav />
      <GuestbookPage />
      <Footer />
    </div>
  );
}

function ContactRoute() {
  return (
    <div className="App bg-ink">
      <Nav />
      <ContactPage />
      <Footer />
    </div>
  );
}

function CaveRoute() {
  return (
    <div className="App bg-ink">
      <Nav />
      <CavePage />
      <BronzeAgeWorld />
      <Footer />
    </div>
  );
}

function NotableRoute() {
  return (
    <div className="App bg-ink">
      <Nav />
      <NotablePage />
      <Footer />
    </div>
  );
}

function HezRoute() {
  return (
    <div className="App bg-ink">
      <Nav />
      <HezPage />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <SiteProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/press" element={<Press />} />
          <Route path="/recipes" element={<RecipesRoute />} />
          <Route path="/guestbook" element={<GuestbookRoute />} />
          <Route path="/contact" element={<ContactRoute />} />
          <Route path="/cave" element={<CaveRoute />} />
          <Route path="/notable" element={<NotableRoute />} />
          <Route path="/hez" element={<HezRoute />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
    </SiteProvider>
  );
}

export default App;
